import type { SentryContext } from './sentry.types';

export interface ApiErrorData {
    errorCode: string;
    errorMessage?: string;
}

export class ApiError extends Error {
    public status?: number | undefined;
    public data?: unknown;
    public context?: SentryContext | undefined;

    // oxlint-disable-next-line max-params
    constructor(message: string, status?: number, data?: unknown, context?: SentryContext) {
        super(message);
        this.status = status;
        this.data = data;
        this.context = context;
    }
}

const AssetRetrievalErrorCodes = {
    UNDEFINED: 'error_undefined_asset_id',
    SOT000: 'error_fetch_unexpected',
    SOT001: 'error_downstream_system_failure',
    SOT002: 'error_fetch_unexpected',
    SOT004: 'error_mapping_asset_failure',
    SOT005: 'error_mapping_asset_failure',
    SOT006: 'error_mapping_asset_failure',
    SOT007: 'error_asset_not_found',
    SOT008: 'error_invalid_asset_type',
    SOT010: 'error_unauthorized',
};

export const ErrorCodes = {
    ...AssetRetrievalErrorCodes,
} as const;

export type ErrorCode = keyof typeof ErrorCodes;
